import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid, Box } from '@mui/material'
import { MuiTextField, MuiButton, AccordionWithArrow, Message } from '../../../../components'
import userManagement from '../../../../services/userManagement.service'
import { useGlobalStore } from '../../../../store'
import { isValidEmail, isValidRespID } from '../../../../util'
import { OuterWrapper } from './style'

const Add = ({ onChange }) => {
  const { company, user } = useGlobalStore()
  const initialFormObj = {
    name: '',
    emailAddress: '',
    password: '',
    retypePassword: ''
  }

  const form = useRef()
  const [formData, setFormData] = useState(initialFormObj)
  const [loader, setLoader] = useState(false)
  const [respDataMessage, setRespDataMessage] = useState({})

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formData,
      [key]: value || null
    }
    setFormData(obj)
  }

  const submitPayload = async (e) => {
    e.preventDefault()
    const obj = {
      name: formData?.name?.trim() || '',
      emailAddress: formData?.emailAddress?.trim() || '',
      password: formData?.password?.trim() || '',
      retypePassword: formData?.retypePassword?.trim() || ''
    }

    if (obj.name === '' || obj.emailAddress === '' || obj.password === '' || obj.retypePassword === '') {
      setRespDataMessage({ type: 'error', msg: 'All fields are mandatory !!' })
      return false
    // } else if (obj.emailAddress.match(/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/)) {
    } else if (!isValidEmail(obj.emailAddress)) {
      // setRespDataMessage({ type: 'error', msg: !isValidEmail(obj.emailAddress) ? 'Invalid Email ID' : '' })
      setRespDataMessage({ type: 'error', msg: 'Invalid Email ID' })
      return false
    } else if (obj.password !== obj.retypePassword) {
      setRespDataMessage({ type: 'error', msg: 'Password in the two fields do not match. Please retry.' })
      return false
    }

    setLoader(true)
    const payload = { emailAddress: obj.emailAddress, userTypeId: user?.UserTypeId || 1 }
    // if (!(payload?.userTypeId === 1)) {
    //   consoleLog('Payload ==============> ', payload)
    // }
    userManagement.getUserApi(payload)
      .then(resp => {
        if (resp?.EmailAddress === obj.emailAddress) {
          setRespDataMessage({ type: 'error', msg: 'A user with this email address already exists in the system. Please Sign In to access your account.' })
          setLoader(false)
        } else if (resp) {
          const finalObject = {
            user: {
              // UserId: user.UserId, // Throwing Mega ERROR
              UserId: '00000000-0000-0000-0000-000000000000',
              Name: obj.name,
              EmailAddress: obj.emailAddress,
              UserTypeId: user?.UserTypeId || 1,
              PasswordSalt: '',
              EncryptedPassword: obj.password
            }
          }
          userManagement.setUserNonEncryptedPasswordApi(finalObject)
            .then(resp2 => {
              if (isValidRespID(resp2)) {
                setRespDataMessage({ type: 'success', msg: 'DONE!!' })
                setLoader(false)
                resetForm()
              } else {
                setRespDataMessage({ type: 'error', msg: `Operation Failed. ${JSON.stringify(resp2)}` })
              }
            })
            .catch(error => {
              setRespDataMessage({ type: 'error', msg: `We are facing some unexpected problem in creating your account. Please try again or contact customer service for assistance. Sorry for the inconvenience. ${JSON.stringify(error)}` })
              setLoader(false)
            })
        } else {
          setRespDataMessage({ type: 'error', msg: `Operation Failed. ${JSON.stringify(resp)}` })
          setLoader(false)
        }
      })
      .catch(error => {
        setRespDataMessage({ type: 'error', msg: `Operation Failed. ${JSON.stringify(error)}` })
        setLoader(false)
      })
  }

  const onload = async () => {
  }

  const resetForm = () => {
    setFormData(initialFormObj)
    onload()
  }

  useEffect(() => {
    if (company?.OrganizationId) onload()
  }, [company?.OrganizationId])

  return (
    <AccordionWithArrow title='Create User for ET' accordionstyle='fieldset'>
      <OuterWrapper>
        <form ref={form} onSubmit={submitPayload} autoComplete='off'>
          <Grid container spacing={2} className='formWrapper'>
            <Grid item xs={12}>
              <MuiTextField
                name='name'
                placeholder='Enter Name'
                label='Name'
                onChange={(e) => onChangeHandler('name', e.target.value)}
                variant='standard'
                value={formData?.name || ''}
              />
            </Grid>
            <Grid item xs={12}>
              <MuiTextField
                name='emailAddress'
                placeholder='Enter Email Address'
                label='Email Address'
                onChange={(e) => onChangeHandler('emailAddress', e.target.value)}
                variant='standard'
                value={formData?.emailAddress || ''}
                inputProps={{ maxlength: 50 }}
              />
            </Grid>
            <Grid item xs={12}>
              <MuiTextField
                name='password'
                placeholder='Enter Password'
                label='Password'
                onChange={(e) => onChangeHandler('password', e.target.value)}
                variant='standard'
                value={formData?.password || ''}
                type='password'
              />
            </Grid>
            <Grid item xs={12}>
              <MuiTextField
                name='retypePassword'
                placeholder='Enter Retype Password'
                label='Retype Password'
                onChange={(e) => onChangeHandler('retypePassword', e.target.value)}
                variant='standard'
                value={formData?.retypePassword || ''}
                type='password'
              />
            </Grid>
            <Grid item xs={12}>
              <Box>
                <MuiButton
                  onClick={submitPayload}
                  type='submit'
                  color='primary'
                  variant='contained'
                  style={{ width: '120px' }}
                  disabled={loader}
                >
                  Sign up
                </MuiButton>
              </Box>
              <Message type={respDataMessage?.type} align='left'>{respDataMessage?.msg || ''}</Message>
            </Grid>
          </Grid>
        </form>
      </OuterWrapper>
    </AccordionWithArrow>
  )
}

Add.propTypes = {
  onChange: PropTypes.func
}

export default Add
